import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex justify-between overflow-hidden rounded divide-x h-4 w-full" }


export default /*#__PURE__*/_defineComponent({
  __name: 'ProgressBlocks',
  props: {
    blocks: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.blocks, (block) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "w-full h-4",
        key: block
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["block h-4", {
          'bg-gray-600': block == 'gray',
          'bg-blue-3': block == 'blue',
          'bg-orange': block == 'orange',
          'bg-green': block == 'green',
          'bg-red': block == 'red',
        }])
        }, null, 2)
      ]))
    }), 128))
  ]))
}
}

})